import script from "./NewButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewButton.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./NewButton.vue?vue&type=style&index=0&id=1d2c781c&module=styles&lang=scss"
cssModules["styles"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__